<template>
  <b-form-checkbox 
    switch 
    size="lg"
    v-model="valueBind"
    >
      <small 
      class="switch switch-text-on position-absolute f-bold mouse-hover" 
      v-if="valueBind"
      >
      ON
      </small>
      <small 
      class="switch switch-text-off position-absolute f-bold mouse-hover" 
      v-if="!valueBind">
      OFF
      </small>
  </b-form-checkbox>
</template>

<script>
export default {
  name: "input_switch",
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },
  computed: {
    valueBind: {
      get () {
        return this.localValue
      },
      set ($event) {
        this.localValue = $event
        this.$emit('input', $event)
      }
    }
  }
}
</script>

<style lang="scss">
  .switch {
    top: 6px;
    font-size: 11px;
    line-height: 14px;
    color: #FFFFFF;
    &-text-on {
      left: -39px;
    }
    &-text-off { 
      left: -19px;
    }
  }

  div.custom-switch.b-custom-control-lg {
    padding-left: 2.50rem;
  }

  label.custom-control-label::before {
    background-color: #C4C4C4;
    border: 0;
    cursor: pointer;
  }

  input.custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: none;
  }

  input.custom-control-input:not(:disabled):active ~ label.custom-control-label::before {
    color: #fff;
    background-color: #000;
    border-color: #000;
  }

  input.custom-control-input:checked ~ label.custom-control-label::before {
    border: 0;
    background-color: #040A10;
  }
  
  .custom-switch.b-custom-control-lg label.custom-control-label::before, .input-group-lg div.custom-switch .custom-control-label::before {
    top: 0;
    height: 25px;
    width: 51px;
    border-radius: 100px;
  }

  div.custom-switch.b-custom-control-lg label.custom-control-label::after, .input-group-lg div.custom-switch label.custom-control-label::after {
    top: 3px;
    width: 19px;
    height: 19px;
    left: -41px;
    cursor: pointer;
    border-radius: 100px;
    background-size: 50% 50%;
    background-color: #FFFFFF;
  }

  div.custom-switch.b-custom-control-lg input.custom-control-input:checked ~ label.custom-control-label::after, input.input-group-lg div.custom-switch input.custom-control-input:checked ~ label.custom-control-label::after {
    transform: translateX(23px);
  }
</style>